import { render, staticRenderFns } from "./HelpDeskTechnicianRequests.vue?vue&type=template&id=53bce060&scoped=true&"
import script from "./HelpDeskTechnicianRequests.vue?vue&type=script&lang=js&"
export * from "./HelpDeskTechnicianRequests.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskTechnicianRequests.vue?vue&type=style&index=0&id=53bce060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bce060",
  null
  
)

export default component.exports